import { computed, inject, Injectable, Signal } from '@angular/core';
import { SettingsService } from '@softline/application';
import {
  MASTERDATA_SEARCH_SETTINGS_DEFAULT,
  SOFTLINE_SETTINGS_MASTERDATA_SEARCH,
} from '../masterdata.shared';
import type { MasterdataSearchSettings } from '../types';

/** Reads/writes the persisted masterdata-search ("Stammdaten Suche") settings via
 *  the shared SettingsService; exposes typed signals with defaults. */
@Injectable({ providedIn: 'root' })
export class MasterdataSearchSettingsService {
  private readonly settings = inject(SettingsService);

  private readonly value = this.settings.get<Partial<MasterdataSearchSettings>>(
    SOFTLINE_SETTINGS_MASTERDATA_SEARCH
  );

  /** Whether the inline dropdown opens on focus/typing. When false, masterdata
   *  fields become F4 fields (F4 hint + only the expanded modal opens). */
  readonly openDropdownOnFocus: Signal<boolean> = computed(
    () =>
      this.value()?.openDropdownOnFocus ??
      MASTERDATA_SEARCH_SETTINGS_DEFAULT.openDropdownOnFocus
  );

  setOpenDropdownOnFocus(open: boolean): void {
    this.settings.setKey<MasterdataSearchSettings>(
      SOFTLINE_SETTINGS_MASTERDATA_SEARCH,
      { ...MASTERDATA_SEARCH_SETTINGS_DEFAULT, ...this.value(), openDropdownOnFocus: open }
    );
    // setKey only updates the in-memory signal — persist to localStorage.
    this.settings.save();
  }
}
